import { RetweetOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { FC, useCallback } from "react";

import { useDevice } from "@app/shared/lib/DeviceProvider";
import { useDrawer } from "@app/shared/lib/hooks";
import { Loc } from "@app/shared/ui";

import { TransferToBonusForm } from "./TransferToBonusForm";

type TransferToBonusProps = {
  minAmount?: number;
  onSuccess: () => void;
};

export const TransferToBonus: FC<TransferToBonusProps> = ({
  minAmount,
  onSuccess,
}) => {
  const device = useDevice();
  const transferModal = useDrawer();

  const handleSuccess = useCallback(() => {
    transferModal.close();
    onSuccess();
  }, [onSuccess]);

  return (
    <>
      <Button
        icon={<RetweetOutlined />}
        size={device.deviceSize === "mobile" ? "large" : "middle"}
        className={device.deviceSize === "mobile" ? "w-100" : undefined}
        onClick={transferModal.open}
      >
        <Loc
          word="Partnership.transaction.transferToBonus"
          default="Transfer to bonus account"
        />
      </Button>

      <Modal
        title={
          <Loc
            word="Partnership.transaction.transferToBonus"
            default="Transfer to bonus account"
          />
        }
        open={transferModal.visible}
        destroyOnClose
        width={400}
        onCancel={transferModal.close}
        footer={null}
      >
        <TransferToBonusForm
          minAmount={minAmount}
          onCancel={transferModal.close}
          onSuccess={handleSuccess}
        />
      </Modal>
    </>
  );
};
